import * as usageListActions from './UsageList/actions';
import * as createEditUsageActions from './CreateEditUsage/actions';
export const actions = {
  ...usageListActions,
  ...createEditUsageActions,
};



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/usage/state/actions.js